import React from "react"
import { motion } from "framer-motion"
import { FiExternalLink } from "react-icons/fi"

const PROJECTS = [
  {
    status: "IN USE",
    title: "Hotel Honi",
    desc: "A hotel management application streamlining room booking, order taking and billing for hotel staff and guests, with efficient database schemas and query optimization.",
    tags: ["Full-stack", "Database design"],
    link: null,
  },
  {
    status: "SHIPPED",
    title: "HelpBuddy",
    desc: "Final year project — a freelancing platform bridging skilled individuals with help seekers. Features AI profile picture verification and Khalti payment integration.",
    tags: ["React Native", "React", "Node.js", "MySQL"],
    link: "https://github.com/Dinesh-Thakuri/HelpBuddy",
  },
  {
    status: "ARCHIVED",
    title: "E-commerce Website",
    desc: "A college assignment building the frontend for an e-commerce site selling electronics — smartphones, gadgets and accessories.",
    tags: ["Frontend", "UI/UX"],
    link: null,
  },
]

export default function Project() {
  return (
    <section id="project" className="bg-ink text-white border-t border-lineSoft py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-baseline gap-3.5 mb-10">
          <span className="font-mono text-xs text-amber">03</span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">Deployed systems</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROJECTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-panel border border-line p-6 flex flex-col h-full"
            >
              <div className="font-mono text-[10px] tracking-widest text-mint mb-3.5">● {p.status}</div>
              <h3 className="font-display font-semibold text-lg mb-2.5">{p.title}</h3>
              <p className="text-muted text-sm mb-4 flex-grow">{p.desc}</p>
              <div className="flex flex-wrap gap-1.5 mb-4">
                {p.tags.map((t) => (
                  <span key={t} className="font-mono text-[10px] text-muted border border-line px-2 py-1">
                    {t}
                  </span>
                ))}
              </div>
              {p.link && (
                <a
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-mono text-xs text-amber hover:underline inline-flex items-center gap-1.5 mt-auto"
                >
                  View on GitHub <FiExternalLink size={12} />
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
